import type { ChatTranscriptItem } from "~/ai-chat/model/chat-message";
import { entityIdFromPath, parseEntityLink } from "~/ai-chat/model/entity-link";

export interface ConversationArtifact {
  resourceId: string;
  name: string;
}

const MARKDOWN_LINK = /\[([^\]]+)\]\(([^)\s]+)\)/g;

// The tracked assets (resources / artifacts) an assistant surfaced in a conversation,
// in first-seen order and deduped by resource id. Derived from the entity links the
// assistant emits — `[name](/resources/<id>)` / `/resources/artifact/<id>` — since
// there is no per-conversation artifact endpoint. Chat-saved artifacts appear here
// once the assistant links them back.
export function collectConversationArtifacts(messages: ChatTranscriptItem[]): ConversationArtifact[] {
  const byId = new Map<string, ConversationArtifact>();
  for (const item of messages) {
    if (item.kind !== "message" || item.role !== "assistant") continue;
    for (const [, text, href] of item.content.matchAll(MARKDOWN_LINK)) {
      const link = parseEntityLink(href);
      if (link === null || (link.type !== "artifact" && link.type !== "model")) continue;
      const resourceId = entityIdFromPath(link.path);
      if (resourceId === null || byId.has(resourceId)) continue;
      byId.set(resourceId, { resourceId, name: text.trim() });
    }
  }
  return [...byId.values()];
}
